import {
  parseInventoryBoxIdFromScan,
  parseInventoryLocationUrl,
} from "@integrator-src/api/inventory-box/inventory-box-scan";

export type InventoryAdjustScanMode = "carton" | "location";

export function inventoryAdjustScanTarget(
  mode: InventoryAdjustScanMode,
  raw: string,
): string | null {
  const trimmed = raw.trim();
  if (trimmed === "") return null;

  if (mode === "carton") {
    const boxHex = parseInventoryBoxIdFromScan(trimmed);
    return boxHex != null ? `/i/${boxHex}` : null;
  }

  const locationTag = parseInventoryLocationUrl(trimmed);
  if (locationTag == null) return null;
  const params = new URLSearchParams({
    sku: locationTag.sku,
    location: String(locationTag.locationId),
  });
  return `/warehouse/recount?${params.toString()}`;
}
